import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import { Button } from '@mui/material'
import { useField } from 'formik'
import { getDataById, updateDataById } from '../apis/generalApis'
import { ScaleLoader } from 'react-spinners'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const NotificationModal = ({ hanldeNotificationModal, modalOpen }) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const user = JSON.parse(localStorage.getItem('user'))
  const [notifications, setNotifications] = React.useState([])

  React.useEffect(() => {
    getNotifications()
  }, [])

  const getNotifications = async () => {
    try {
      const response = await getDataById('show-notifications', {
        user_id: user?.id,
      })
      if (response?.success === true) {
        setNotifications(response?.unReadNotifications)
      }
      console.log(response)
    } catch (error) {
      console.error(error)
    }
  }

  const handleClearAll = async () => {
    try {
      if (!notifications || notifications?.length === 0) return
      setIsLoading(true)
      const body = { user_id: user?.id }
      const response = await updateDataById('mark-read-notifications', body)
      if (response?.success === true) {
        hanldeNotificationModal(false)
        getNotifications()
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={modalOpen}
        onClose={() => hanldeNotificationModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="mb-3">
            <p className="fs-24 color-primary d-inline font-weight-bold">
              Notifications
            </p>
            <p
              className="fs-12 color-primary float-end d-inline mt-2 font-weight-bold pointer"
              onClick={handleClearAll}
            >
              Clear all
            </p>
          </div>
          <div className="notifications">
            {notifications &&
              notifications?.map((noti, index) => (
                <div
                  className="py-2 px-3 d-flex justify-content-between align-items-center"
                  key={index}
                >
                  <div>
                    <p className="fs-16" style={{ marginRight: '3.5rem' }}>
                      You received an order
                    </p>
                    <p className="fs-14 opacity-25">Lorem ipsum reik wyeye</p>
                  </div>
                  <div className="text-left">
                    <p className="fs-10 opacity-25">10:50pm</p>
                    <p
                      className="fs-10 opacity-25"
                      style={{ visibility: 'hidden' }}
                    >
                      {noti?.time_ago}
                    </p>
                  </div>
                </div>
              ))}
            {/* {(!notifications || notifications?.length === 0) && (
              <p>No notifications to show.</p>
            )} */}
            {/* <div className="py-2 px-3 d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-16" style={{ marginRight: '3.5rem' }}>
                  You received an order
                </p>
                <p className="fs-14 opacity-25">Lorem ipsum reik wyeye</p>
              </div>
              <div className="text-left">
                <p className="fs-10 opacity-25">10:50pm</p>
                <p
                  className="fs-10 opacity-25"
                  style={{ visibility: 'hidden' }}
                >
                  10:50am
                </p>
              </div>
            </div>
            <div className="py-2 px-3 d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-16" style={{ marginRight: '3.5rem' }}>
                  You received an order
                </p>
                <p className="fs-14 opacity-25">Lorem ipsum reik wyeye</p>
              </div>
              <div className="text-left">
                <p className="fs-10 opacity-25">10:50pm</p>
                <p
                  className="fs-10 opacity-25"
                  style={{ visibility: 'hidden' }}
                >
                  10:50am
                </p>
              </div>
            </div>
            <div className="py-2 px-3 d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-16" style={{ marginRight: '3.5rem' }}>
                  You received an order
                </p>
                <p className="fs-14 opacity-25">Lorem ipsum reik wyeye</p>
              </div>
              <div className="text-left">
                <p className="fs-10 opacity-25">10:50pm</p>
                <p
                  className="fs-10 opacity-25"
                  style={{ visibility: 'hidden' }}
                >
                  10:50am
                </p>
              </div>
            </div> */}
          </div>
          <div className="mt-5">
            <Button
              disableElevation
              className="mt-5 pointer"
              id="btn-primary-no-shadow"
              fullWidth
              onClick={() => hanldeNotificationModal(false)}
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default NotificationModal
